import { apiUrl } from "util/config";
import { message } from "antd";
import $ from "jquery";

var Actions = {
  getTrainings: query => {
    return new Promise((resolve, reject) => {
      var settings = {
        async: true,
        crossDomain: true,
        url: apiUrl + "api/getTrainingsForMonth?date=" + query,
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        },
        success: function(response) {
          if (response.error) {
            message.error(response.userMessage);
          }
          resolve(response);
        },
        error: function(error) {
          if (error.status == 401) {
            message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else {
            message.error("Some error has occurred.");
          }
        }
      };

      $.ajax(settings).done();
    });
  }
};

export default Actions;
